export default __webpack_public_path__ + "static/media/Rectangle2.69cc9a65.jpg";